import React from 'react';
import { Tag, Tooltip } from 'antd';
import { UserOutlined, TabletOutlined, ToTopOutlined } from '@ant-design/icons';

const ExamTag = ({ 
  exam, 
  className, 
  children,
  showJourneyTooltip = true,
  showDeviceTooltip = true
}) => {
  const {
    admission_patient_exam_state: state,
    extra_data,
    exam_type,
    exam_name
  } = exam || {};

  const displayContent = children || (exam_type === 'laboratory' ? 'Laboratorio' : exam_name);
  const titleStart = state === 'done' ? 'Respondido' : 'Respondiendo encuesta'

  return (
    <Tag className={`${state || ''} ${className || ''}`}>
      {showJourneyTooltip && extra_data?.from_journey && (
        <Tooltip placement="left" title={`${titleStart} desde journey`}>
          <UserOutlined />
        </Tooltip>
      )}
      {showDeviceTooltip && extra_data?.from_device && (
        <Tooltip placement="left" title={`${titleStart} desde dispositivo`}>
          <TabletOutlined />
        </Tooltip>
      )}
      {((showJourneyTooltip && extra_data?.from_journey) ||
        (showDeviceTooltip && extra_data?.from_device)) && ' '}
      {displayContent}
      {extra_data?.is_operative_conditional && ' (Condicional)'}
      {showDeviceTooltip && extra_data?.pending_submission && state !== 'done' && (
        <Tooltip placement="right" title="Respondido sin enviar">
          <ToTopOutlined />
        </Tooltip>
      )}
    </Tag>
  );
};

export default ExamTag;